// Hook to access form mode context
import { useContext } from 'react';
import { FormModeContext } from '../context/FormModeContext';
import type { FormModeContextValue } from '../context/FormModeContext';

export function useFormMode(): FormModeContextValue {
  const context = useContext(FormModeContext);
  if (!context) {
    throw new Error('useFormMode must be used within FormModeProvider');
  }
  return context;
}
